import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError, catchError } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * A service for handling scheduled reports.
 * This service has been stubbed out to compile cleanly, with the original
 * logic preserved in comments for future implementation.
 */
@Injectable({
  providedIn: 'root'
})
export class ScheduledReportsService {

  private http = inject(HttpClient);

  // Original URL properties, commented out to align with modern DI practices.
  /*
  private scheduledReportsUrl = environment.scheduledReportUrl;
  private org = environment.org;
  private addNewScheduledReportUrl =  this.scheduledReportsUrl + this.org + '/new-scheduled-report';
  private getScheduledReportsUrl =    this.scheduledReportsUrl + this.org + '/get-scheduled-report';
  private editUserScheduledReportsUrl =   this.scheduledReportsUrl + this.org + '/edit-user-scheduled-reports';
  private deleteScheduledReportUrl =   this.scheduledReportsUrl + this.org + '/delete-scheduled-report';
  */

  constructor() { }

  /**
   * Sends scheduled reports.
   * Original logic used a hardcoded URL and promises.
   * @returns An observable that completes without returning data.
   */
  sendScheduledReportsNow(): Observable<any> {
    /*
    let options = {
      headers : {
        'Content-Type' : 'application/json'
      }
    };
    return this.http.get('https://ykkbbhr0k9.execute-api.us-east-1.amazonaws.com/prod/test-sched-reports-test-only', options)
      .toPromise()
      .catch(this.handleError);
    */
    return of(null);
  }

  /**
   * Runs a report for contracts.
   * Original logic used a PUT request with a manually stringified body.
   * @param report The report data.
   * @returns An observable of the API response.
   */
  runReportContracts(report: any): Observable<any> {
    /*
    let options = {
      headers : {
        'Content-Type' : 'application/json'
      }
    }
    let jsonReadyBody = {
      'schedReportData': report
    }
    let body = JSON.stringify(jsonReadyBody);
    return this.http.put(environment.runReportContractsUrl + environment.org, body, options)
      .toPromise()
      .catch(this.handleError);
    */
    return of(null);
  }

  /**
   * Sends a report now.
   * Original logic used a PUT request with a manually stringified body.
   * @param report The report data.
   * @returns An observable of the API response.
   */
  sendReportNow(report: any): Observable<any> {
    /*
    let options = {
      headers : {
        'Content-Type' : 'application/json'
      }
    };
    let jsonReadyBody = {
      'org': environment.org,
      'report': report
    }
    let body = JSON.stringify(jsonReadyBody);
    return this.http.put(environment.domainForCommunications + 'sendreport', body, options)
      .toPromise()
      .catch(this.handleError);
    */
    return of(null);
  }

  /**
   * Edits a user's scheduled report.
   * Original code was commented out.
   * @param scheduledReport The scheduled report data.
   * @returns An observable of the API response.
   */
  editUserScheduledReport(scheduledReport: any): Observable<any> {
    /*
    console.log('inside editUserScheduledReport');
    let jsonReadyBody = {
      'email': this.globalDataService.email,
      'scheduledReport': scheduledReport
    }
    if (environment.sso) {
      jsonReadyBody.email = this.globalDataService.userId;
      if (!jsonReadyBody.email) {
        console.error('scheduled-reports-service | editUserScheduledReport | system is SSO but user has no userId');
      }
    }
    let options = {
      headers : {
        'Content-Type' : 'application/json'
      }
    };
    let body = JSON.stringify(jsonReadyBody);
    return this.http.post(this.editUserScheduledReportsUrl, body, options)
      .toPromise()
      .catch(this.handleError);
    */
    return of(null);
  }

  /**
   * Deletes a scheduled report.
   * Original code was commented out.
   * @param scheduledReportName The name of the report to delete.
   * @returns An observable of the API response.
   */
  deleteScheduledReport(scheduledReportName: any): Observable<any> {
    /*
    console.log('scheduled report name --> ', scheduledReportName);
    let jsonReadyBody = {
      'email': this.globalDataService.email,
      'ReportName': scheduledReportName
    }
    if (environment.sso) {
      jsonReadyBody.email = this.globalDataService.userId;
      if (!jsonReadyBody.email) {
        console.error('scheduled-reports-service | deleteScheduledReport | system is SSO but user has no userId');
      }
    }
    let options = {
      headers : {
        'Content-Type' : 'application/json'
      }
    };
    let body = JSON.stringify(jsonReadyBody);
    return this.http.post(this.deleteScheduledReportUrl, body, options)
      .toPromise()
      .catch(this.handleError);
    */
    return of(null);
  }

  /**
   * Shares a report with a user.
   * Original code was commented out and used promises and async/await.
   * @param scheduledReportData The report data to share.
   * @param userEmail The email of the user to share with.
   * @returns An observable of the API response.
   */
  shareReportWithUser(scheduledReportData: any, userEmail: string): Observable<any> {
    /*
    let jsonReadyBody = {
      'email': userEmail,
      'scheduledReport': scheduledReportData
    }
    if (environment.sso) {
      if (this.globalDataService.allUsers.length === 0) {
        await this.globalDataService.getAllUsersPromise();
      }
      let foundUser = this.globalDataService.allUsers.find( user => user.email === userEmail);
      if (foundUser) {
        jsonReadyBody.email = foundUser.id;
      } else {
        console.error('scheduled-reports-service | addNewScheduledReport | system is SSO but user has no userId');
      }
    }
    let options = {
      headers : {
        'Content-Type' : 'application/json'
      }
    };
    let body = JSON.stringify(jsonReadyBody);
    return this.http.post(this.addNewScheduledReportUrl, body, options)
                    .toPromise()
                    .catch(this.handleError);
    */
    return of(null);
  }

  /**
   * Adds a new scheduled report.
   * Original code was commented out.
   * @param scheduledReportData The scheduled report data.
   * @returns An observable of the API response.
   */
  addNewScheduledReport(scheduledReportData: any): Observable<any> {
    /*
    console.log('scheduled report data --> ', scheduledReportData);
    let jsonReadyBody = {
      'email': this.globalDataService.email,
      'scheduledReport': scheduledReportData
    }
    if (environment.sso) {
      jsonReadyBody.email = this.globalDataService.userId;
      if (!jsonReadyBody.email) {
        console.log('ERROR - scheduled-reports-service - addNewScheduledReport - system is SSO but user has no userId');
      }
    }
    let options = {
      headers : {
        'Content-Type' : 'application/json'
      }
    };
    let body = JSON.stringify(jsonReadyBody);
    return this.http.post(this.addNewScheduledReportUrl, body, options)
      .toPromise()
      .catch(this.handleError);
    */
    return of(null);
  }

  /**
   * Retrieves all scheduled reports for a user.
   * Original code was commented out and used promises.
   * @returns An observable of the reports.
   */
  getScheduledReports(): Observable<any> {
    /*
    let options = {
      params : {
        'email' : this.globalDataService.email
      },
      headers : {
        'Content-Type' : 'application/json'
      }
    };
    if (environment.sso && this.globalDataService.userId) {
      options.params.email = this.globalDataService.userId;
    }
    return this.http.get(this.getScheduledReportsUrl, options).toPromise();
    */
    return of(null);
  }
}
